import './HeaderLocation.scss';
import PropTypes from 'prop-types';

const HeaderLocation = ({ location, isOrderByUbication }) => (
  <div className="location-pending">
    <div>
      <h6>{isOrderByUbication ? 'Ubicación' : 'Proveedor'}</h6>
      <div>{location}</div>
    </div>
  </div>
);

export default HeaderLocation;

HeaderLocation.propTypes = {
  location: PropTypes.string,
  isOrderByUbication: PropTypes.bool.isRequired
};

HeaderLocation.defaultProps = {
  location: ''
};
